type KeyMap = Record<string, string>

interface RuntimeKeyState {
  projectKeys: KeyMap
  conversationKeys: KeyMap
  buildKeys: KeyMap
  currentProjectKeyByTab: Record<string, string>
  currentConversationKeyByTab: Record<string, string>
}

const state: RuntimeKeyState = {
  projectKeys: {},
  conversationKeys: {},
  buildKeys: {},
  currentProjectKeyByTab: {},
  currentConversationKeyByTab: {},
}

export const runtimeKeyStore = {
  // Project keys
  getProjectKeys: (): KeyMap => ({ ...state.projectKeys }),
  setProjectKeys: (map: KeyMap): void => { state.projectKeys = { ...map } },
  upsertProjectKeys: (partial: KeyMap): void => {
    state.projectKeys = { ...state.projectKeys, ...partial }
  },
  removeProjectKey: (id: string): void => {
    const { [id]: _, ...rest } = state.projectKeys
    state.projectKeys = rest
  },

  // Conversation keys
  getConversationKeys: (): KeyMap => ({ ...state.conversationKeys }),
  setConversationKeys: (map: KeyMap): void => { state.conversationKeys = { ...map } },
  upsertConversationKeys: (partial: KeyMap): void => {
    state.conversationKeys = { ...state.conversationKeys, ...partial }
  },
  removeConversationKey: (id: string): void => {
    const { [id]: _, ...rest } = state.conversationKeys
    state.conversationKeys = rest
  },

  // Build additional info keys
  getBuildKeys: (): KeyMap => ({ ...state.buildKeys }),
  setBuildKeys: (map: KeyMap): void => { state.buildKeys = { ...map } },
  upsertBuildKeys: (partial: KeyMap): void => {
    state.buildKeys = { ...state.buildKeys, ...partial }
  },
  removeBuildKey: (id: string): void => {
    const { [id]: _, ...rest } = state.buildKeys
    state.buildKeys = rest
  },

  // Tab-scoped current project key
  getCurrentProjectKey: (tabId: string): string =>
    state.currentProjectKeyByTab[tabId] || "",
  setCurrentProjectKey: (tabId: string, key: string): void => {
    state.currentProjectKeyByTab[tabId] = key
  },

  // Tab-scoped current conversation key
  getCurrentConversationKey: (tabId: string): string =>
    state.currentConversationKeyByTab[tabId] || "",
  setCurrentConversationKey: (tabId: string, key: string): void => {
    state.currentConversationKeyByTab[tabId] = key
  },

  reset: (): void => {
    state.projectKeys = {}
    state.conversationKeys = {}
    state.buildKeys = {}
    state.currentProjectKeyByTab = {}
    state.currentConversationKeyByTab = {}
  },
}
